import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import transcriptSpeakersFetched, {
	type TranscriptSpeakerPayload,
	type TranscriptSpeakersFetchedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakersFetched';
import transcriptSpeakersFetchFailed, {
	type TranscriptSpeakersFetchFailedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakersFetchFailed';
import type FetchTranscriptSpeakers from '@Application/Beneficiaries/Transcripts/Queries/FetchTranscriptSpeakers';
import { get } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = TranscriptSpeakersFetchedAction | TranscriptSpeakersFetchFailedAction;

export default (query: FetchTranscriptSpeakers) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<TranscriptSpeakerPayload[]>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/interviews/${query.interviewId}/transcript/speakers`,
			);

			const action = transcriptSpeakersFetched(payload, query.interviewId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = transcriptSpeakersFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
